import styled from 'styled-components';
import { breakPoints } from '~/styles/break-points';

export const StyledAvpErrorWrapper = styled.div`
	z-index: 10;
	position: absolute;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	background: ${(props) => props.theme.sys.gradient.elevation.level1.fill};
	padding: 0 20px;
	${breakPoints({
		'768': `padding: 0;`,
	})};

	> p {
		margin-bottom: 20px;
		text-align: center;
		${breakPoints({
			'768': `text-align: left;`,
		})};
	}
`;
